import { Container, Image } from 'react-bootstrap'
import FreeReportWYDModal from '../wyd/FreeReportWYDModal';
import React, { useState } from 'react'

function IndexHeader (props) {
    
    const [lgShow, setLgShow] = useState(false);
    
    return (
        <>
        <div className="section-index-header">
            <Container>
                <h1><span className="text-free-report">FREE REPORT REVEALS</span><br/>
                What your Doctor wasn't taught in med school<br/>
                <span className="text-about-nutrition">about nutrition that you need to know</span></h1>
                <p><strong className="text-download">Download this critical report and discover: </strong></p>
                <ul>
                    <li>7 important things about nutrition you need to know</li>
                    <li>How others have used nutrition to not only halt but reverse disease</li>
                    <li>The importance of anti-oxidants, omegas and the prevention of free radical damage</li>
                    <li>Why this expert doctor recommends you use a supplementation program </li>
                    <li>Plus, much more!</li>
                </ul>
                <p className="text-click-button">CLICK THE BUTTON BELOW TO GET THIS <strong>FREE REPORT</strong><br/>
                Reading this could dramatically improve your life!</p>
                <p><a className="btn btn-download" onClick={() => setLgShow(true)}>DOWNLOAD NOW</a></p>
                <Image src="../images/wyd/img-doctor05.png" alt="What your Doctor" className="img-fluid d-none d-md-block"/>
            </Container>
        </div>
        <FreeReportWYDModal show={lgShow} onHide={() => setLgShow(false)} global={props.global}/>
        <style jsx global>{`

                .section-index-header {
                    background: url(../images/wyd/bg-index-header01.jpg) no-repeat;
                    background-size: cover;
                }

                .section-index-header .container {
                    position: relative;
                    padding-bottom: 25px;
                }

                .section-index-header h1 {
                    font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                    font-size: 62px;
                    margin-bottom: 15px;
                }

                .section-index-header h1 .text-free-report {
                    color: #00aec7;
                    font-size: 68px;
                }

                .section-index-header h1 .text-about-nutrition {
                    font-family: 'Poppins', Helvetica, Arial, sans-serif;
                    font-size: 30px;
                    line-height: 25px;
                    display: block;
                    letter-spacing: 2px;
                }

                .section-index-header img {
                    position: absolute;
                    bottom: 0px;
                    right: 0px;
                    width: 37%;
                }

                .section-index-header strong.text-download {
                    font-size: 17px;
                }

                .section-index-header ul {
                    margin: 0px 0px 20px;
                    padding: 0px;
                }

                .section-index-header ul li {
                    list-style: none;
                    background: url(../images/wyd/img-check01.png) no-repeat left 8px;
                    padding: 6px 0px 6px 30px;
                }

                .section-index-header .text-click-button {
                    margin-bottom: 20px;
                }

                .section-index-header .btn-download {
                    font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                    font-size: 44px;
                    background: #94b92c;
                    padding: 7px 45px 2px;
                    border-radius: 0px;
                    color: #fff;
                }

                .section-index-header .btn-download:hover {
                    background: #86a62e;
                }

                @media (min-width: 1200px) {

                    .section-index-header img {
                        right: -120px;
                    }

                }

                @media (min-width: 992px) and (max-width: 1199.98px) {

                    .section-index-header img {
                        right: 0px;
                        width: 37%;
                    }

                }

                @media (min-width: 768px) and (max-width: 991.98px) {

                    .section-index-header img {
                        right: -100px;
                    }

                }

                @media (max-width: 767.98px) {	

                    .section-index-header h1 {
                        font-size: 42px;
                        text-align: center;
                    }

                    .section-index-header h1 .text-free-report {
                        font-size: 48px;
                    }

                    .section-index-header h1 .text-about-nutrition {
                        text-align: center;
                    }

                    .section-index-header .btn-download {
                        font-size: 34px;
                        padding: 7px 35px 2px;
                    }

                }

            `}</style>
        </>
    );
}

export default IndexHeader;